import * as React from 'react';
import { IDatabaseField } from 'src/services/database';
import { FormattedMessage } from 'react-intl';

export default (props: { field: IDatabaseField, onChange: (id: string, value: any) => void }) => {
    const renderOptions = (option: string) => {
        return <option key={`${props.field.id}-${option}`} value={option}>{option}</option>
    };
    const handleChange = (event: any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        props.onChange(props.field.id, value);
    };
    let extra: any = {}
    try {
        extra = JSON.parse(props.field.extra)
    } catch (ex) { }
    return (
        <div className="formrow">
            <div className="formcol">
                <label className="text-muted font-weight-bold pb-0"><u>{props.field.label}{props.field.required ? '*' : ''}</u></label>
                <small className="form-text text-muted pb-3">{extra && extra.help}</small>
                <select value={props.field.value} onChange={handleChange} className="custom-select" autoComplete="off">
                    <FormattedMessage tagName="option" id="page.field.select.option" defaultMessage="Select..." />
                    {props.field.options.map(renderOptions)}
                </select>
            </div>
        </div>
    )
};



// WEBPACK FOOTER //
// ./src/client/pages/Select.tsx